// extracted by mini-css-extract-plugin
module.exports = {"title":"About_title__3b5Ft"};